import script from "./OrganizationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationItem.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationItem.vue?vue&type=style&index=0&id=744b6254&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744b6254"]])

export default __exports__